import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Divider, Form, Input, Row, Typography } from 'antd'
import { PhoneOutlined } from '@ant-design/icons'
import ButtonCell from '../ButtonCell'
import { getDomain, useWindowSize } from '../../utils'

const { Title, Text, Link } = Typography

export default function GetQuoteAndCustomerLinks() {
  const zipCodeInput = useRef(null)
  const [zipCode, setZipCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const windowSize = useWindowSize()
  const isMobile = windowSize.width > 1024

  useEffect(() => {
    if (zipCodeInput.current && windowSize.width && isMobile && !document.activeElement) {
      zipCodeInput.current.focus()
    }
  }, [zipCodeInput, windowSize, isMobile])

  const handleZipCodeChange = event => {
    const value = event.target.value.replace(/\D/g, '')
    setZipCode(value)
  }

  const handleClick = event => {
    setErrorMessage('')
    if (zipCode && zipCode.length > 0 && zipCode.length === 5) {
      const newWindow = window.open('https://' + getDomain('quote') + `/default.aspx?zip=${zipCode}`, '_self')
      if (newWindow) newWindow.opener = null
    } else {
      setErrorMessage('Please enter a valid 5 digit ZIP Code.')
    }
  }
  const handleRetrieveClick = event => {
    setErrorMessage('')
    window.open('https://' + getDomain('quote') + '/retrieve-saved-quote.aspx', '_self')
  }
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      setErrorMessage('')
      if (zipCode && zipCode.length > 0 && zipCode.length === 5) {
        const newWindow = window.open('https://' + getDomain('quote') + `/default.aspx?zip=${zipCode}`, '_self')
        if (newWindow) newWindow.opener = null
      } else {
        setErrorMessage('Please enter a valid 5 digit ZIP Code.')
      }
    }
  }

  var paymentLink = "/"
  var pathname
  if (typeof window !== 'undefined') {
    pathname = window.location.pathname
    paymentLink = 'https://' + getDomain("payments")
    console.log(pathname)
  }
  
  const handlePaymentClick = event => {
    setErrorMessage('')
    window.open('https://' + getDomain("payments"), '_self')
  }
  return (
    <>
      <div style={{minHeight: '32vh !important'}} className="cure-inner-container container-404">
        <Row justify="center" className="container-wrapper">
          <Col className="get-quote" style={{ textAlign: 'center' }}>
            <Row>
              <Col className="text-center header-title">
                <Title className="title font-size-52" level={2}>
                  Get A Quote
                </Title>
              </Col>
            </Row>
            <Row>
              <Col className="margin-auto">
                <Text className="sub-header-title text-center line-height-1 margin-bottom-12">
                  Quote <div className="period" /> Apply <div className="period" /> Save
                </Text>
                <Text className="sub-title text-center margin-bottom-18"> Three easy steps for next day coverage.</Text>
              </Col>
            </Row>

            <Row>
              <Col className="margin-auto">
                <Form className="form-inline" layout="inline">
                  <Form.Item>
                    <Input
                      ref={zipCodeInput}
                      maxLength={5}
                      onChange={handleZipCodeChange}
                      onKeyDown={handleKeyDown}
                      placeholder="ZIP CODE"
                      value={zipCode}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="start-quote qs-start-quote"
                      onClick={handleClick}
                      rel="noopener noreferrer"
                      style={{ background: '#ff8000', border: 'none', width: '120px' }}
                    >
                      START QUOTE
                    </Button>
                  </Form.Item>
                </Form>
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                <Row style={{ width: '100%' }}>
                  <Col className="past-quote-container">
                    <Link className="past-quote" onClick={handleRetrieveClick} target="_self">
                      Retrieve Saved Quote
                    </Link>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Divider type="vertical" className='desktop-divider' />
          <Col className="customer-lnks" style={{ textAlign: 'center' }}>
            <Row>
              <Col className="text-center header-title">
                <Title className="title font-size-52" level={2}>
                  Customer Links
                </Title>
              </Col>
            </Row>
            <Row>
              <Col className="margin-auto">
                <Text className="sub-header-title text-center line-height-1 margin-bottom-12">
                  <Link
                    className="rsa sub-header-title text-center line-height-1 margin-bottom-12"
                    href="tel:+18005352873"
                  >
                    <PhoneOutlined className="phone" />
                    800-535-CURE (2873)
                  </Link>
                </Text>
              </Col>
            </Row>
            <Row justify="center" className='button-cell-holder'>
              <Col>
                <ButtonCell link="/my-account" logoType="get_id_card" mainText="GET" subText="ID CARD" />
                <ButtonCell onClick={handlePaymentClick} logoType="make_payment" mainText="MAKE" subText="PAYMENT" /> 
                <ButtonCell link="/claims/fnol-form" logoType="file_claim" mainText="REPORT" selfOpen={true} subText="CLAIM" />
                <ButtonCell
                  link="/my-account"
                  logoType="manage_policy"
                  mainText="MANAGE"
                  selfOpen={true}
                  subText="POLICY"
                />
              </Col>
            </Row>
          </Col>
          <Row className='mobile-divider-container'>
            <Divider type="horizontal" className='mobile-divider' />
          </Row>
        </Row>
      </div>
    </>
  )
}
